export default __webpack_public_path__ + "static/media/recorte_13.fc869f39.JPG";